import React from 'react';

import { ConsultationResponseAnswer } from 'types';
import { RpcResponseAnswer } from '..';

export type ResponseAnswersProps = {
  answers: ConsultationResponseAnswer[];
  showEdit: boolean;
};

export const RpcResponseAnswers: React.FC<ResponseAnswersProps> = ({ answers, showEdit }) => {
  return (
    <>
      {answers.map((answer) => (
        <RpcResponseAnswer
          key={answer.id ?? answer.questionId}
          answer={answer}
          showEdit={showEdit}
        />
      ))}
    </>
  );
};
